
define(
	'TavanoTeam.CSExtensions.CSCertCapture.Router'
,   [
        'Profile.Model'
    ,   'TavanoTeam.CSExtensions.CSCertCaptureExt.List.View'
    ,   'TavanoTeam.CSExtensions.CSCertCaptureExt.NewCert.View'
    ,   'TavanoTeam.CSExtensions.CSCertCapture.Collection'
    ,   'TavanoTeam.CSExtensions.CSCertCapture.Model'
    ,   'AjaxRequestsKiller'

    ,   'Backbone'
    ,   'underscore'
	]
,   function (
        ProfileModel
    ,   CertCaptureListView
    ,   CertCaptureNewCert
    ,   CertCaptureCollection
    ,   CertCaptureModel
    ,   AjaxRequestsKiller

    ,   Backbone
    ,   _
	)
{
	'use strict';

	return  Backbone.Router.extend({
        routes: {
            'certificates/list': 'certList'
        ,   'certificates/new': 'certNew'
        }
    ,   initialize: function(option)
        {
            this.application = option.application;
            this.profileModel = ProfileModel.getInstance();
            this.curr_user = this.profileModel.get('internalid');
        }
    ,   certList: function()
        {
            var self = this;

            if(this.profileModel.get('isLoggedIn') !== 'T')
            {
                return self.application.getLayout().notFound();
            }

            var cert_collection = new CertCaptureCollection()
            ,   certListView = new CertCaptureListView({
                application: self.application
            ,   collection: cert_collection
            });

            cert_collection.fetch({
                data: {
                    userid: self.curr_user
                }
            ,   killerId: AjaxRequestsKiller.getKillerId()
            })
            .done(function() 
            {
                certListView.showContent();
            });
        }
    ,   certNew: function()
        {
            var self = this;
            
            if(this.profileModel.get('isLoggedIn') !== 'T')
            {
                return self.application.getLayout().notFound();
            }

            var custName = this.profileModel.get('name')
            ,   entityId = custName.substring(0, custName.indexOf(' '))
            ,   cert_model = new CertCaptureModel()
            ,   newCertView = new CertCaptureNewCert({
                application: self.application
            ,   model: cert_model
            });

            cert_model.fetch({
                data: {
                    actionType: 'new_cert'
                ,   entityId: entityId
                }
            ,   killerId: AjaxRequestsKiller.getKillerId()
            })
            .done(function() 
            {
                newCertView.showContent();
            });
        }
    });
});
